<FouMdDrawer :isOpen="isOpen" @close="handleClose" width="800px" position="right" :bordered="true">
    <template #header>
        <div :class="$style['header-container']" data-qa-id="submit-drawer-header">
            <MdTypography v-if="!reviewAPIinProgress" tag="h5" variant="heading5--medium" color="spirits--900"
                data-qa-id="submit-drawer-project-name">
                {{ ingestionData?.metadata?.projectName }}
            </MdTypography>
            <IngestionLoader v-else height="32px" width="100px" borderRadius="8px" data-qa-id="submit-drawer-project-loader" />
            <ProgressCol v-if="isLiveIngestion && !reviewAPIinProgress" :params="{ status: ingestionData?.status }"
                :textClass="$style['progress-col-text']" data-qa-id="submit-drawer-status" />
        </div>
    </template>

    <template #body>
        <div v-if="ingestionData?.status === 'error' || ingestionData?.status === 'in_progress'"
            :class="$style['ingestion-status-image']" data-qa-id="submit-drawer-status-block">
            <NoResultFound v-if="ingestionData?.status === 'error'" data-qa-id="submit-drawer-error"
                :noResultsTitle="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.error_page_title')"
                :noResultsContent="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.error_page_content')"
                :iconToShow="ProjectErrorImage" :imgHeight="240" :imgWidth="240" />
            <NoResultFound v-else-if="ingestionData?.status === 'in_progress'" data-qa-id="submit-drawer-transferring"
                :noResultsTitle="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.transferring_page_title')"
                :noResultsContent="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.transferring_page_content')"
                :iconToShow="TransferProjectImage" :imgHeight="240" :imgWidth="240" />
        </div>
        <!-- Tabs -->
        <div v-if="ingestionData?.status === 'success' || ingestionData?.status === 'in_work'"
            :class="$style['tabs-container']" data-qa-id="submit-drawer-tabs">
            <div :class="[$style.tablink, { [$style['active-tab']]: activeTab === 'overview' }]" data-qa-id="tab-overview"
                @click="openTab('overview')">
                <MdTypography tag="span" :variant="activeTab === 'overview' ? 'micro1--medium' : 'micro1--regular'">
                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.tabs.overview') }}
                </MdTypography>
            </div>
            <div :class="[$style.tablink, { [$style['active-tab']]: activeTab === 'families' }]" data-qa-id="tab-families"
                @click="openTab('families')">
                <MdTypography tag="span" :variant="activeTab === 'families' ? 'micro1--medium' : 'micro1--regular'">
                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.tabs.families') }}
                </MdTypography>
            </div>
            <div :class="[$style.tablink, { [$style['active-tab']]: activeTab === 'notes' }]" data-qa-id="tab-notes"
                @click="openTab('notes')">
                <MdTypography tag="span" :variant="activeTab === 'notes' ? 'micro1--medium' : 'micro1--regular'">
                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.tabs.notes') }}
                </MdTypography>
            </div>
        </div>
        <div v-if="ingestionData?.status === 'success' || ingestionData?.status === 'in_work' || !ingestionData?.status"
            :class="$style['drawer-body']" data-qa-id="submit-drawer-body">
            <DrawerLoading v-if="reviewAPIinProgress" />
            <!-- Overview Tab Content -->
            <div v-else>
                <div id="overview" :class="[$style['tab-content']]" v-show="activeTab === 'overview'">
                    <div :class="$style['overview-content']" data-qa-id="overview-content">
                        <!-- Left Column -->
                        <div :class="$style['overview-column']">
                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.project_category') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ ingestionData?.metadata?.type }}
                                </MdTypography>
                            </div>

                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.families') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ ingestionData?.metadata?.totalFamilies }}
                                </MdTypography>
                            </div>

                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.uploaded_styles') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ ingestionData?.metadata?.totalStyles }}
                                </MdTypography>
                            </div>

                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.uploaded_font_files') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ ingestionData?.metadata?.totalFonts }}
                                </MdTypography>
                            </div>
                        </div>

                        <!-- Right Column -->
                        <div :class="$style['overview-column']">
                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.target_foundry') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ ingestionData?.foundry?.name }}
                                </MdTypography>
                            </div>

                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.last_updated_on') }}
                                </MdTypography>
                                <MdTypography tag="span" variant="body1--medium" :class="$style['info-value']">
                                    {{ formattedUpdatedDate }}
                                </MdTypography>
                            </div>

                            <div :class="$style['info-row']">
                                <MdTypography tag="span" variant="body2--regular" color="spirits--700"
                                    :class="$style['info-label']">
                                    {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.last_modified_by') }}
                                </MdTypography>
                                <div :class="$style['user-info']">
                                    <MdTypography tag="div" variant="body1--medium" :class="$style['user-name']">
                                        {{ ingestionData?.owner?.displayName }}
                                    </MdTypography>
                                    <MdTypography tag="div" variant="micro1--regular" color="spirits--700"
                                        :class="$style['user-email']">
                                        {{ ingestionData?.owner?.email }}
                                    </MdTypography>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Information Note -->
                    <div :class="$style['info-note']" data-qa-id="submit-drawer-info-note">
                        <div :class="$style['info-note-content']">
                            <MdIconFailed rotate="down" size="sm" color="spirits--600" />
                            <MdTypography tag="span" variant="body2--medium" :class="$style['info-note-text']">
                                {{ $t('pages.inventory_ingestion_hub.submit_drawer.overview.info_note') }}
                            </MdTypography>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Families Tab Content -->
            <div id="families" :class="[$style['tab-content']]" v-show="activeTab === 'families'">
                <div :class="$style['families-content-header']" data-qa-id="families-header">
                    <div :class="$style['families-content-header-left']">
                        <div :class="$style['families-content-header-families']">
                            <MdTypography tag="span" variant="heading7--medium">
                                {{ $t('pages.inventory_ingestion_hub.submit_drawer.families.families') }}
                            </MdTypography>
                            <span :class="$style['families-count']">
                                <MdTypography tag="span" variant="body2--regular">
                                    {{ ingestionData?.metadata?.totalFamilies }}
                                </MdTypography>
                            </span>
                        </div>
                        <div :class="$style['families-content-header-font-files']">
                            <MdTypography tag="span" variant="heading7--medium">
                                {{ $t('pages.inventory_ingestion_hub.submit_drawer.families.font_files') }}
                            </MdTypography>
                            <span :class="$style['font-files-count']">
                                <MdTypography tag="span" variant="body2--regular">
                                    {{ ingestionData?.metadata?.totalFonts }}
                                </MdTypography>
                            </span>
                        </div>
                    </div>
                    <div :class="$style['families-content-header-right']" data-qa-id="families-search">
                        <TextField id="family_search_input" v-model="familySearch" data-qa-id="familySearch"
                            name="familySearch" :searchEnable="true" :input-class="$style['families-search-input']"
                            :placeholder="$t('pages.inventory_ingestion_hub.family_search_placeholder')"
                            :modelValue="familySearch" :showErrorMessage="false" :showCrossIcon="true"
                            :onSearchCrossIconClick="clearSearch" />
                    </div>
                </div>
                <div :class="$style['families-accordion']" data-qa-id="families-accordion">
                    <!-- Show accordion when there are search results -->
                    <Accordion v-if="filteredFamilies.length > 0" :items="filteredFamilies" :maxOpen="5"
                        data-qa-id="families-accordion-component">
                        <template #header="{ item }">
                            <div :class="$style['family-header']">
                                <div :class="$style['family-info']">
                                    <MdTypography tag="div" variant="body1--medium" color="spirits--900"
                                        :class="$style['family-name']">
                                        {{ item.familyName }}
                                    </MdTypography>
                                    <MdTypography tag="div" variant="micro1--medium" color="spirits--600"
                                        :class="$style['family-details']">
                                        {{ item.displayFamilyName || item.familyName }}
                                    </MdTypography>
                                </div>
                                <div :class="$style['family-stats']">
                                    <template v-if="item.isEdit">
                                        <MdTypography tag="span" variant="body2--regular" color="spirits--900"
                                            :class="$style['stat-badge']">
                                            {{ item.revisionDetails?.userMetaData?.binaries?.filter(binary =>
                                            binary?.status !== undefined && binary?.status !== null &&
                                            String(binary.status).trim() !== '').length }}
                                            {{$t('pages.inventory_ingestion_hub.accordian.file_uploaded') }} |
                                            {{ item.revisionDetails?.userMetaData?.binaries?.length }} {{
                                            item.revisionDetails?.userMetaData?.binaries?.length > 1 ?
                                            $t('pages.inventory_ingestion_hub.accordian.files') :
                                            $t('pages.inventory_ingestion_hub.accordian.file') }}
                                        </MdTypography>
                                    </template>
                                    <template v-else>
                                        <MdTypography :class="$style['stat-badge']" tag="span" color="spirits--900"
                                            variant="body2--regular">
                                            {{ item.revisionDetails?.userMetaData?.binaries?.length }} {{
                                            item.revisionDetails?.userMetaData?.binaries?.length > 1 ?
                                            $t('pages.inventory_ingestion_hub.accordian.files') :
                                            $t('pages.inventory_ingestion_hub.accordian.file') }}
                                        </MdTypography>
                                    </template>
                                    <div v-if="isLiveIngestion"
                                        :class="$style['submission-download-dropdown-container']" @click.stop data-qa-id="submission-download-dropdown">
                                        <md-dropdown size="medium" variant="text" width="150px" alignment="right"
                                            id="zip-download-dropdown" ref="dropdownRef" data-qa-id="download-dropdown">
                                            <MdIconDownload slot="icon-start" />
                                            <MdDropdownItem label="Font files (ZIP)" value="Font" data-qa-id="download-font-zip"
                                                @click="downloadSubmission(item.submissionId, 'font')">
                                            </MdDropdownItem>
                                            <MdDropdownItem label="Images (ZIP)" value="Image" data-qa-id="download-image-zip"
                                                @click="downloadSubmission(item.submissionId, 'image')">
                                            </MdDropdownItem>
                                        </md-dropdown>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template #content="{ item }">
                            <div :class="$style['family-content']" :key="index">
                                <FontDisplayStylesTable :data="item" :isLiveIngestion="isLiveIngestion" />
                            </div>
                        </template>
                    </Accordion>

                    <!-- Show no results message when search returns empty -->
                    <div v-else-if="familySearch.trim()" :class="$style['no-results']" data-qa-id="families-no-results">
                        <NoResultFound data-qa-id="families-no-results-component"
                            :noResultsTitle="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.title')"
                            :noResultsContent="$t('pages.inventory_ingestion_hub.submit_drawer.no_results.content')"
                            :iconToShow="NoResultImage" :imgHeight="240" :imgWidth="240" />
                    </div>
                </div>
            </div>

            <!-- Notes Tab Content -->
            <div id="notes" :class="[$style['tab-content']]" v-show="activeTab === 'notes'" data-qa-id="notes-tab">
                <Notes :upload-notes="ingestionData?.ingestionNotes && ingestionData?.ingestionNotes[0]?.note"
                    :family-notes="familyNotes" data-qa-id="notes-component" />
            </div>
        </div>
    </template>

    <template #footer>
        <div :class="$style['drawer-footer']" v-if="!reviewAPIinProgress && !isLiveIngestion" data-qa-id="submit-drawer-footer">
            <MdButton color="lightgrey" @handleclick="handleDownloadCSV" size="large" data-qa-id="btn-download-csv">
                {{ $t('pages.inventory_ingestion_hub.submit_drawer.footer.download_csv') }}
            </MdButton>
            <MdButton color="blue" @handleclick="handleSubmit" size="large" :disabled="ingestionSubmissionLoader"
                data-qa-id="btn-submit-ingestion">
                {{ $t('pages.inventory_ingestion_hub.submit_drawer.footer.submit') }}
                <MdSpinner v-if="ingestionSubmissionLoader" slot="icon-start" color="white" size="16" showbox="false"
                    aria-label="Submitting Ingestion"></MdSpinner>
            </MdButton>
        </div>
        <div :class="$style['drawer-footer']" v-else-if="!reviewAPIinProgress && isLiveIngestion"
            data-qa-id="submit-drawer-footer">
            <MdButton color="lightgrey" @handleclick="handleClose" size="large" data-qa-id="btn-close">
                {{ $t('pages.inventory_ingestion_hub.submit_drawer.footer.close') }}
            </MdButton>
            <MdButton color="blue" @handleclick="handleDownloadCSV" size="large" data-qa-id="btn-download-csv-live"
                :disabled="ingestionData?.status !== 'success'">
                {{ $t('pages.inventory_ingestion_hub.submit_drawer.footer.download_csv') }}
            </MdButton>
        </div>

        <div :class="$style['drawer-footer']" v-else>
            <IngestionLoader height="48px" width="88px" borderRadius="8px" />
            <IngestionLoader height="48px" width="88px" borderRadius="8px" />
        </div>
    </template>
</FouMdDrawer>